import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { SensorConfigurationRequest } from 'src/api'
import { Entities } from 'src/enums'
import { APIList } from 'src/interfaces'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  params: {
    uniqueId: string;
    limit?: number;
    offset?: number;
  }
  options?: Omit<UseQueryOptions<APIList<SensorConfigurationRequest>, Error>, 'queryKey' | 'queryFn'>;
}

export const useSensorConfigurationRequestListRequest = ({ params, options }: RequestParams) => {
  const api = useApiInstance()
  const { uniqueId, limit, offset } = params

  return useQuery<APIList<SensorConfigurationRequest>, Error>(
    [Entities.SensorConfigurationRequests, uniqueId, limit, offset],
    async () => {
      const { data } = await api.v1AdminSensorsUniqueIdConfigurationRequestsGet(uniqueId, limit, offset)
      return data as unknown as APIList<SensorConfigurationRequest>
    },
    options
  )
}
